export default __webpack_public_path__ + "static/maintenance-img-1a6242cf19dc615cc941ab467a1489a1.png";